import { useState } from 'react'
import apiMaestras from '../api/Maestras/api-maestras';
import { DocumentoTecnico } from '../models/Maestras/maestras.model';

export const useGestionDocumentosTecnicos = () => {
    const [cantidadPaginas, setCantidadPaginas] = useState(10);
    const cambiarCantidadPaginas = (e: any, value: any) => {
        setCantidadPaginas(value);
    };


    const [documentosTecnicos, setDocumentosTecnicos] = useState<DocumentoTecnico[]>([]);
    const obtenerDocumentosTecnicos = async() => {
        try {
            const documentosTecnicos = await apiMaestras.obtenerDocumentosTecnicos();
            setDocumentosTecnicos(documentosTecnicos);
        } catch (error) {
            console.log(error);
        }
    }



    return {
        cantidadpaginas: cantidadPaginas,
        cambiarCantidadPaginas,
        documentosTecnicos,
        obtenerDocumentosTecnicos
    } 
}
